import { useState } from 'react';
import Typography from '../Atoms/Typography';
import { Icon } from '../Icons';
import { isEnterPressed } from 'utils/keyboard';
import useViewTestResult from '../../hooks/Onboarding/useViewTestResult';

import './viewTestResult.css';

const COOL_DOWN_PERIOD_FOR_JOB_LIST_CALL = 30000;

function ViewTestResult() {
  const [viewResultButtonDisabled, setViewResultButtonDisabled] =
    useState(false);
  let {
    getJobList,
    currentConfiguration,
    handleDocLinkClick,
    showNoTestError,
  } = useViewTestResult();
  let isYamlBasedSample =
    currentConfiguration.testType !== 'sampleTest' ? true : false;

  /**
   * here we will be preventing user to click on view result
   * for 30 seconds after first click, so that if an error
   * has occured, he doesn't make multiple calls
   */
  function handleViewResultClick() {
    getJobList('');
    setViewResultButtonDisabled(true);
    window.setTimeout(() => {
      setViewResultButtonDisabled(false);
    }, COOL_DOWN_PERIOD_FOR_JOB_LIST_CALL);
  }
  return (
    <div className="ltw-mt-30px ltw-items-center ltw-gap-20px ltw-mb-10px">
      {showNoTestError && (
        <div className="ltw-flex ltw-gap-8px ltw-items-center ltw-mb-15px">
          <Icon name="info-blue" width="14" height="14" color="#EA1A1A" />
          <Typography
            variant="h2"
            color="ltw-text-error-msg"
            fontSize="ltw-text-14"
            lineHeight="ltw-leading-17"
          >
            We couldn't detect a test yet. Did you run your test?
            <a
              target="_blank"
              className="ltw-text-primary"
              role="button"
              tabIndex="0"
              href={process.env.REACT_APP_HYPERTEST_DOCUMENTAION_LINK}
              onClick={handleDocLinkClick}
              onKeyDown={handleDocLinkClick}
              rel="noreferrer"
            >
              {' '}
              View Docs
            </a>
          </Typography>
        </div>
      )}
      <div
        onClick={(e) => handleViewResultClick()}
        onKeyDown={(e) => isEnterPressed(e) && handleViewResultClick()}
        role="button"
        tabIndex="0"
        className={`ltw-flex ltw-gap-8px ltw-items-center ltw-justify-center ${
          isYamlBasedSample ? 'ltw-w-1/2' : ''
        } ${viewResultButtonDisabled ? 'view-result-disabled' : ''}`}
      >
        <Typography
          variant="h2"
          color="ltw-text-primary"
          fontSize="ltw-text-14"
          lineHeight="ltw-leading-17"
          cursor="pointer"
        >
          View Test Results
        </Typography>
        <Icon name="redirect-horizontal-arrow" width="12" height="14" />
      </div>
    </div>
  );
}
export default ViewTestResult;
